// Module
var code = "<i class=\"fa fa-fw fa-sort\" title=\"{{'Drag to reorder items'|translate}}\"></i>";
// Exports
module.exports = code;